(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["circular-progress"] && !Shopify.designMode) return;
  try {
    (function() {
    const els = document.querySelectorAll('[data-prefstest-circular-progress]');
    if (!els.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((ioEntry) => {
        if (!ioEntry.isIntersecting) return;
        observer.unobserve(ioEntry.target);
        animateProgress(ioEntry.target);
      });
    }, { threshold: 0.3 });

    els.forEach((el) => observer.observe(el));

    function animateProgress(el) {
      const pct = parseFloat(el.dataset.progressPct) || 0;
      const circumference = parseFloat(el.dataset.progressCircumference) || 0;
      const duration = parseInt(el.dataset.progressDuration, 10) || 1200;
      const fill = el.querySelector('.prefstest-circular-progress__fill');
      const counter = el.querySelector('[data-progress-counter]');
      const start = performance.now();

      function step(now) {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const currentPct = eased * pct;
        const offset = circumference - (currentPct / 100) * circumference;

        if (fill) fill.setAttribute('stroke-dashoffset', offset);
        if (counter) counter.textContent = Math.round(currentPct) + '%';

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }

      requestAnimationFrame(step);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-text"] && !Shopify.designMode) return;
  try {
    /* Update variant-reactive custom text blocks on variant change */
  document.addEventListener('variant:update', function (event) {
    var detail = event.detail;
    if (!detail) return;
    var variantId = detail.resource && detail.resource.id;
    var html = detail.data && detail.data.html;

    document.querySelectorAll('.custom-text[data-variant-reactive]').forEach(function (block) {
      /* Approach 1: JSON variant map (for variant metafield source) */
      var mapEl = block.querySelector('[data-ct-variant-map]');
      if (mapEl && variantId) {
        try {
          var map = JSON.parse(mapEl.textContent);
          var val = map[variantId];
          var textEl = block.querySelector('[data-ct-text]');
          if (textEl) {
            textEl.textContent = val != null ? val : '';
          }
        } catch (e) { /* ignore parse errors */ }
        return;
      }

      /* Approach 2: Re-render from fetched HTML (for richtext dynamic sources) */
      if (!html) return;
      var match = block.className.match(/custom-text--([a-f0-9-]+)/);
      if (!match) return;
      var freshBlock = html.querySelector('.custom-text--' + match[1]);
      if (!freshBlock) return;
      var textEl = block.querySelector('[data-ct-text]');
      var freshTextEl = freshBlock.querySelector('[data-ct-text]');
      if (textEl && freshTextEl && textEl.innerHTML !== freshTextEl.innerHTML) {
        textEl.innerHTML = freshTextEl.innerHTML;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
